import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';

const getPrimaryEmail = (state) => resolveProp('protect.fetchProtectEmails.data.primaryEmail', state) || {};
const getAdditionalEmails = (state) => resolveProp('protect.fetchProtectEmails.data.additionalEmails', state) || [];
const getAdditionalEmailLimit = (state) => resolveProp('protect.fetchProtectEmails.data.additionalLimit', state);
const getProtectActions = (state) => resolveProp('protect.fetchProtectActions.data', state) || {};
const getProtectInfo = (state) => resolveProp('protect.fetchProtectInfo.data', state) || {};
const getProtectMeta = (state) => resolveProp('protect.fetchProtectMeta.data', state) || {};

export const getEmails = createSelector(
    getPrimaryEmail,
    getAdditionalEmails,
    getAdditionalEmailLimit,
    (primaryEmail, additionalEmails, additionalLimit) => ({
        emails: [{ ...primaryEmail, isPrimary: true }, ...additionalEmails],
        additionalLimit,
    }),
);

export const getActions = createSelector(getProtectActions, (actions) => actions);

export const getInfo = createSelector(getProtectInfo, (info) => info);

export const getMeta = createSelector(getProtectMeta, (meta) => meta);
